import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	wrapperNote: {
		id: 'personal-settings-preference-fields.common.group-notification-emails-wrapper.wrapper-note',
		defaultMessage:
			"We'll group together notifications for the same issues into one email. How often do you want to receive these?",
		description: '',
	},
	wrapperNoteIssueTermRefresh: {
		id: 'personal-settings-preference-fields.common.group-notification-emails-wrapper.wrapper-note-issue-term-refresh',
		defaultMessage:
			"We'll group together notifications for the same work items into one email. How often do you want to receive these?",
		description: '',
	},
});
